import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { TEMPLATE_ID } from "../../../../api/constants";
import useFansUnitedSDK from "../../../../hooks/useFansUnitedSDK";
import { getMyOverallRanking, getMyRankingRequest, getRankingRequest } from "../../../../redux/ranking";
import styles from "./Points.module.css";

const Points = ({ currentPoints, weeklyPosition, isLoadingWeeklyPosition }) => {
	const { t } = useTranslation();
	const [_isLoading, setIsLoading] = useState(false);
	const [_toastMessage, setToastMessage] = useState(null);
	const fansUnitedSDK = useFansUnitedSDK();
	const dispatch = useDispatch();

	const myRankingList = useSelector(getMyOverallRanking);

	// Use weekly position if provided, otherwise use overall ranking
	const userRanking =
		weeklyPosition !== undefined ? weeklyPosition : myRankingList.filter((template) => template.id === TEMPLATE_ID)[0]?.position || "-";
	const userPoints = myRankingList.filter((template) => template.id === TEMPLATE_ID)[0]?.points || "-";

	// Show loading state for weekly position
	const showPositionLoader = isLoadingWeeklyPosition && weeklyPosition === undefined;

	useEffect(() => {
		if (!fansUnitedSDK) return;

		getData();
		getPersonalRankingData();
	}, [fansUnitedSDK]);

	const getData = () => {
		setIsLoading(true);
		dispatch(getRankingRequest(fansUnitedSDK))
			.then(() => {
				setIsLoading(false);
			})
			.catch((error) =>
				setToastMessage({
					text: error.data?.error?.message || "Error!",
					type: "error",
				}),
			);
	};

	const getPersonalRankingData = () => {
		setIsLoading(true);
		dispatch(getMyRankingRequest(fansUnitedSDK))
			.then(() => {
				setIsLoading(false);
			})
			.catch((error) =>
				setToastMessage({
					text: error.data?.error?.message || "Error!",
					type: "error",
				}),
			);
	};

	return (
		<div className={styles.container}>
			<div className={styles.title}>{t("predictions.points.totalPoints")}</div>
			<div className={styles.separatorTop} />
			<div className={styles.statsContainer}>
				<div className={styles.statItem}>
					<div className={styles.statValue}>{showPositionLoader ? <div className={styles.miniLoader}></div> : userRanking}</div>
					<div className={styles.statLabel}>{t("predictions.points.currentPosition")}</div>
				</div>
				<div className={styles.statItem}>
					<div className={styles.statValueBig}>{currentPoints}</div>
					<div className={styles.statLabelBig}>{t("predictions.points.points")}</div>
				</div>
				<div className={styles.statItem}>
					<div className={styles.statValue}>{userPoints}</div>
					<div className={styles.statLabel}>{t("predictions.points.totalPointsLabel")}</div>
				</div>
			</div>
		</div>
	);
};

export default Points;
